import React from "react";
import { Instagram, MapPin, Phone, Mail, Sparkles } from "lucide-react";

const ADDRESS = "201-15230 84 Ave, Surrey, BC V3S 2N1";
const MAP_EMBED = `https://maps.google.com/maps?q=${encodeURIComponent(ADDRESS)}&z=16&output=embed`;
const DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;

function LocationMap() {
  return (
    <div className="mt-14 grid md:grid-cols-3 gap-6 items-stretch" data-testid="location-map-section">
      <div className="md:col-span-2 rounded-sm overflow-hidden border border-white/10 h-72 md:h-80">
        <iframe
          title="Pink Glow Studio location"
          data-testid="location-map"
          src={MAP_EMBED}
          className="w-full h-full"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="glass-card rounded-sm p-7 flex flex-col justify-center">
        <MapPin className="w-6 h-6 text-[#FF2079] mb-4" />
        <div className="eyebrow mb-2">Find Us</div>
        <div className="font-display text-2xl text-white leading-snug">201-15230 84 Ave<br />Surrey, BC V3S 2N1</div>
        <a
          href={DIRECTIONS}
          target="_blank"
          rel="noreferrer"
          data-testid="get-directions-link"
          className="pink-glow-btn mt-6 inline-flex items-center justify-center bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-11 px-6 text-[10px] tracking-[0.28em] uppercase transition-colors"
        >
          Get Directions
        </a>
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#0A0A0A] py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-[#FF2079]" />
              <span className="font-display text-2xl text-white">
                Pink<span className="text-[#FF2079]">Glow</span> Studio
              </span>
            </div>
            <p className="mt-4 text-[#A09CA3] max-w-md leading-relaxed text-sm">
              A high-end beauty &amp; wellness atelier dedicated to making every
              guest feel radiant, restored, and rare.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-5">Visit</div>
            <ul className="space-y-3 text-sm text-[#A09CA3]">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FF2079] flex-shrink-0" />
                <a href={DIRECTIONS} target="_blank" rel="noreferrer" data-testid="footer-address-link" className="hover:text-white transition-colors">201-15230 84 Ave<br />Surrey, BC V3S 2N1</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#FF2079] flex-shrink-0" />
                <span>+1 236-664-1100</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#FF2079] flex-shrink-0" />
                <span>hello@pinkglow.studio</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-5">Hours</div>
            <ul className="space-y-2 text-sm text-[#A09CA3]">
              <li>Mon – Fri · 09:00 — 20:00</li>
              <li>Saturday · 10:00 — 19:00</li>
              <li>Sunday · 11:00 — 18:00</li>
            </ul>
            <a
              href="#"
              data-testid="footer-instagram-link"
              className="mt-6 inline-flex items-center gap-2 text-sm text-white hover:text-[#FF2079] transition-colors"
            >
              <Instagram className="w-4 h-4" />
              @pinkglow.studio
            </a>
          </div>
        </div>

        <LocationMap />

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#A09CA3]">
          <span>© {new Date().getFullYear()} Pink Glow Studio. All rights reserved.</span>
          <span className="tracking-widest uppercase">Crafted with intention.</span>
        </div>
      </div>
    </footer>
  );
}
